<div class="row">
  <div class="col-12">
    <sb-card>
      <div card-body>
        <div class="row">
          <div class="col-5">
            <div class="d-flex align-items-center flex-column h-100">
              <div class="flex-grow-1 w-100 align-items-center d-flex">
                <sb-comp-player-reporting-header
                  *ngPermissions="permissionService.Permission.ss_nm_reporting"
                  [sbRouterLinkActive]="'d-block'"
                  [isLinkActive]="util.RoutingID.playerReporting"
                  class="w-100 d-none"></sb-comp-player-reporting-header>
                <div *ngPermissions="permissionService.Permission.ss_nm_reporting" class="w-100 d-none"
                     [sbRouterLinkActive]="'d-block'" [isLinkActive]="util.RoutingID.airtimeReporting">
                  <h5 class="mb-5">{{'lang.dashboard.broadcastingQuota' | translate}}</h5>
                  <sb-comp-airtime-reporting-header class="w-100"></sb-comp-airtime-reporting-header>
                </div>
                <sb-comp-location-reporting-header
                  *ngIf="permissionService.hasPermission(permissionService.Permission.ss_nm_reporting) && permissionService.hasPermission(permissionService.Permission.ss_fm_reporting)"
                  [sbRouterLinkActive]="'d-block'"
                  [isLinkActive]="util.RoutingID.locationReporting"
                  class="w-100" style="display: none"></sb-comp-location-reporting-header>
              </div>
              <div class="flex-grow-1 w-100 align-items-center d-flex">
                <p
                  class="m-0">{{'lang.reporting.time' | translate}} {{dateTime.toString() | date : 'dd.MM.yyyy | HH:mm'}}</p>
              </div>
            </div>
          </div>
          <div class="col-7">
            <ul class="big-nav-tabs nav-tabs d-flex">
              <li class="nav-item flex-grow-1 flex-shrink-0 col-sm" *ngPermissions="permissionService.Permission.ss_nm_reporting">
                <a class="nav-link d-flex flex-grow-1 text-center justify-content-center"
                   [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.playerReporting"
                   [sbRouterLink]="util.RoutingID.playerReporting">
                  <sb-icon icon="playerPieChart"></sb-icon>
                  <p style="font-size: 15px;"
                     class="py-2 m-0 font-weight-bold">{{'nav.reporting.network.playerReporting' | translate}}</p>
                </a>
              </li>
              <li class="nav-item flex-grow-1 flex-shrink-0 col-sm"
                  *ngIf="permissionService.hasPermission(permissionService.Permission.ss_nm_reporting) && permissionService.hasPermission(permissionService.Permission.ss_fm_reporting)">
                <a class="nav-link d-flex flex-grow-1 text-center justify-content-center"
                   [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.locationReporting"
                   [sbRouterLink]="util.RoutingID.locationReporting">
                  <sb-icon icon="locationStreet"></sb-icon>
                  <p style="font-size: 15px;"
                     class="py-2 m-0 font-weight-bold">{{'nav.reporting.network.locationReporting' | translate}}</p>
                </a>
              </li>
              <li class="nav-item flex-grow-1 flex-shrink-0 col-sm pr-0"
                  *ngPermissions="permissionService.Permission.ss_nm_reporting">
                <a class="nav-link d-flex flex-grow-1 text-center justify-content-center"
                   [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.airtimeReporting"
                   [sbRouterLink]="util.RoutingID.airtimeReporting">
                  <sb-icon icon="barChart"></sb-icon>
                  <p style="font-size: 15px;"
                     class="py-2 m-0 font-weight-bold">{{'nav.reporting.network.airtimeReporting' | translate}}</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>

<router-outlet></router-outlet>

